<div class="h-full">
    <mat-card class="mat-elevation-z0 px-5 pb-3 h-full flex flex-col">
        <mat-card-title class="flex justify-content-between mt-1">
            <div class="text-xl font-bold">{{ 'txPoAccounts.personal_accounts' | translate }}</div>
            <div>
                <button class="tx-settings-button" mat-icon-button
                        [matMenuTriggerFor]="settings"
                >
                    <fa-icon icon="cog" class="large-icon"></fa-icon>
                </button>
                <mat-menu #settings="matMenu">
                    <div mat-menu-item>
                        <mat-slide-toggle (click)="toggleDayBalance($event)" [(ngModel)]="ShowDayBalance"
                                          color="primary">
                            {{ 'txPoAccounts.show_day_balance' | translate }}
                        </mat-slide-toggle>
                    </div>
                </mat-menu>
            </div>
        </mat-card-title>
        <mat-card-subtitle>
            <!-- The group list is unwrapped here rather than inside the panel body so the header can
                 show the count from the same subscription. A second `| async` would issue a second
                 getWfGroups request, because the service shares the call without a reset connector. -->
            <div *ngIf="(myTabStateService.TabStates$ | async) as TabStates">
              <ng-container *ngIf="workflowGroups$ | async as workflowGroups">
                <mat-accordion>
                    <mat-expansion-panel
                            class="mat-elevation-z0"
                            hideToggle
                            (opened)="onTabOpen('f3')"
                            (closed)="onTabClose('f3')"
                            [expanded]="TabStates.f3 == null || TabStates.f3 == true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="flex space-x-2">
                                    <div class="ml-1">
                                        <div class="transition-all rotate-0 {{ TabStates.f3 ? 'rotate-90' : '' }}">
                                            <fa-icon icon="chevron-right"></fa-icon>
                                        </div>
                                    </div>
                                    <div class="text-xl font-bold">
                                        {{ 'general.filter' | translate }}
                                    </div>
                                    <!-- Inside mat-panel-title so an active filter stays visible
                                         while the panel is collapsed. -->
                                    <div class="flex items-center text-sm"
                                         [class.font-bold]="(SelectedGroups?.length ?? 0) < workflowGroups.length"
                                         [class.text-red-600]="(SelectedGroups?.length ?? 0) < workflowGroups.length">
                                        {{ SelectedGroups?.length ?? 0 }} / {{ workflowGroups.length }}
                                    </div>
                                </div>
                                <!-- Alle/Keine live in the header row so they take no extra line.
                                     stopPropagation keeps the click from toggling the panel. -->
                                <div class="flex items-center space-x-2 ml-auto mr-2">
                                    <button mat-stroked-button class="compact-select-btn"
                                            (click)="$event.stopPropagation(); setAllGroups(true, workflowGroups)">
                                        {{ 'general.selectAll' | translate }}
                                    </button>
                                    <button mat-stroked-button class="compact-select-btn"
                                            (click)="$event.stopPropagation(); setAllGroups(false, workflowGroups)">
                                        {{ 'general.selectNone' | translate }}
                                    </button>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="mb-4">
                            <mat-chip-list multiple>
                                <mat-chip
                                        *ngFor="let group of workflowGroups"
                                        class="workflow-chip"
                                        [selected]="SelectedGroups.includes(group.id)"
                                        [color]="SelectedGroups.includes(group.id) ? 'primary' : undefined"
                                        (click)="toggleChip(group.id)">
                                    {{ group.name }}
                                </mat-chip>
                            </mat-chip-list>
                        </div>
                        
                        <div>
                            <!-- Neuer Nutzer-Filter (unabhängig von Gruppen) -->
                            <div>
                                <!-- Nutzer-Select mit Suchfunktion -->
                                <mat-form-field class="w-full" appearance="outline">
                                    <mat-label>{{ 'txPoAccounts.filterByUsers' | translate }}</mat-label>
                                    <mat-select #userSelect name="userFilterSelect" id="userFilterSelect"
                                        [(ngModel)]="SelectedUsers" (selectionChange)="onUsersSelected($event.value)"
                                        multiple>

                                        <!-- Suchfeld -->
                                        <mat-option>
                                            <ngx-mat-select-search [formControl]="searchControlUsers"
                                                [placeholderLabel]="'txPoAccounts.searchUsers' | translate"
                                                [noEntriesFoundLabel]="'txPoAccounts.noUsersFound' | translate"
                                                (keyup)="onSearchUsers($event)">
                                            </ngx-mat-select-search>
                                        </mat-option>

                                        <!-- Nutzer-Optionen -->
                                        <mat-option *ngFor="let user of filteredUsersArray" [value]="user.value">
                                            {{ user.label }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-icon matSuffix *ngIf="SelectedUsers && SelectedUsers.length > 0"
                                        class="cursor-pointer" (click)="clearUserFilter(); $event.stopPropagation()">
                                        close
                                    </mat-icon>
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
              </ng-container>
            </div>
        </mat-card-subtitle>
        <mat-card-content *ngIf="workflows$ | async as workflows" class="flex-grow overflow-hidden">
            <div id="calendar" class="h-full flex flex-col relative">
                <h1 class="text-center mt-0">{{ currentDateRangeText }}</h1>
                <div class="datepicker-container">
                    <input #dateInput
                           [matDatepicker]="picker"
                           [formControl]="dateControl"
                           style="width: 0; padding: 0; border: none; margin: 0; visibility: hidden;"
                           (dateChange)="onDateSelected($event)">
                    <mat-datepicker #picker></mat-datepicker>
                </div>
                <div class="flex-grow overflow-hidden relative">
                    <full-calendar #calendar [deepChangeDetection]="true" [options]="CalendarOptions"></full-calendar>
                </div>
            </div>

        </mat-card-content>
    </mat-card>
    <div *ngIf="isButtonVisible" class="bg-white border-solid border-2 rounded z-index-1000"
         [ngStyle]="{'position': 'absolute', 'top.px': mouseY, 'left.px': mouseX}">
        <button mat-button style="display: block; width: 100%"
                (click)="openFzeDialog()">{{ 'txApplyBooking.missingTime' | translate }}
        </button>
        <button mat-button style="display: block; width: 100%" (click)="openTypeDialog()">{{ 'txPoAccounts.pzeOrder' | translate }}</button>
    </div>
</div>
